// fleetService.ts
import { HubConnection } from '@microsoft/signalr';
import { normalizeShipDto } from '../types/ship-types';

export async function warpFleet(connection: HubConnection, playerId: string) {
  const data = await connection.invoke('WarpFleetToBelt', playerId);
  // Backend returns { Message: string }, not fleet data directly usually, but let's check Hub.
  // Hub returns { Message: string }.
  // Wait, the frontend expects fleet data?
  // The original service returned data.fleet.
  // The Hub method WarpFleetToBelt returns { Message: string }.
  // This means the frontend won't get the updated fleet immediately from this call.
  // However, SignalR usually pushes updates or we should fetch game state after.
  // Or I should update Hub to return Fleet.
  // For now, let's just return what Hub returns, and rely on GameState update loop or explicit fetch.
  return data;
}

export async function recallFleet(connection: HubConnection, playerId: string) {
  const data = await connection.invoke('RecallFleet', playerId);
  return data;
}
